import { MessageCircle } from "lucide-react";
import { WA_LINK } from "@/constants/site";

const WhatsAppFloat = () => (
  <a
    href={WA_LINK}
    target="_blank"
    rel="noopener noreferrer"
    data-testid="whatsapp-float-btn"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-5 right-5 z-50 flex items-center gap-2 px-5 py-3 rounded-full bg-emerald-500 hover:bg-emerald-400 text-white font-bold text-xs font-mono uppercase tracking-wider shadow-xl shadow-emerald-500/30 transition-colors"
  >
    <MessageCircle size={18} />
    WhatsApp 24/7
  </a>
);

export default WhatsAppFloat;
